module.exports = __webpack_public_path__ + "img/ax.32761e56.svg";